import { BellOutlined } from '@ant-design/icons';
import { Badge, Button, Tooltip } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { selectChatUnreadCount } from 'src/redux/slices/chatNotifications';
import { useAppSelector } from 'src/redux/store';

const ChatNotificationBadge: FC = () => {
  const unreadCount = useAppSelector(selectChatUnreadCount);
  const navigate = useNavigate();

  return (
    <Tooltip title={unreadCount > 0 ? `안읽은 채팅 ${unreadCount}개` : '안읽은 채팅 없음'}>
      <Badge count={unreadCount} size='small' offset={[-2, 2]}>
        <Button type='text' icon={<BellOutlined />} onClick={() => navigate('/channel/chat')} aria-label='매장 채팅' />
      </Badge>
    </Tooltip>
  );
};

export default ChatNotificationBadge;
